
import React from 'react';

import { getOpsubAddress, getOpsubName } from '../../../reducers/opsub';

import ObjectInfoValues from '../ObjectInfoValues';

const IsknOpsubInfo = ({data}) => {

    const opsub = data.opsub[0];

    const opsubName = getOpsubName(opsub);
    const opsubAddress = getOpsubAddress(opsub);

    return (
        <React.Fragment>
            <ObjectInfoValues items={[
                {
                    title: 'Jméno / Název',
                    value: opsubName
                },
                {
                    title: 'Adresa',
                    value: opsubAddress
                },
                {
                    title: 'Typ',
                    value: opsub.opsub_type
                }
            ]}/>
        </React.Fragment>
    );
}

export default IsknOpsubInfo;
